export const publicVersion = "2.8.1-70-gd23b7517-2026-06-02T08-14-19Z";